import { useWatch } from 'react-hook-form';

export const useFormData = (): any => useWatch();

export const useFieldValue = (name: string): any => {
  const value = useWatch({ name });
  return value === undefined ? '' : value;
};
